/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './Boleto25BoletoVenceu.css';
import Container from '../../atoms/Container/Container';
import CustomEmblaCarousel from '../CustomEmblaCarousel/CustomEmblaCarousel';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function Boleto25BoletoVenceu() {
  const [showMsg, setShowMsg] = useState(false);
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <section id="boleto-venceu">
        <div className="boleto-venceu-mobi">
          <picture>
            <source type="image/webp" srcSet="assets/boleto25/img-boleto-venceu.webp" />
            <source type="image/png" srcSet="assets/boleto25/img-boleto-venceu.png" />
            <img
              src="assets/boleto25/img-boleto-venceu.png"
              alt="Mulher branca de cabelo curto pesquisando sobre vencimento do boleto."
              className="img-boleto-venceu"
            />
          </picture>

          <ContainerHome24>
            <h3 className="boleto-venceu-titulo">Seu boleto venceu?</h3>
            <p className="boleto-venceu-texto">
              Ao realizar o pagamento de seu boleto vencido, você evita o aumento dos juros e conta
              com um dia a dia mais confortável para você e sua família. Confira abaixo como gerar a
              2ª via de seu boleto:
            </p>
            {/* <p className="boleto-venceu-texto">
              Se seu boleto estiver vencido até 10 dias, você também pode emitir uma segunda via
              pela{' '}
              <a href="" target="_blank">
                Área do Cliente
              </a>
              .
            </p> */}
            {/* <p className="boleto-venceu-texto margin-extra">
              <b>
                Se seu boleto estiver vencido há mais de 10 dias, confira nossa página de
                renegociação
              </b>
            </p> */}
            <div className="passos-gerar-boleto">
              <p className="passo-gerar-boleto">
                <b>1.</b> Acesse o{' '}
                <a
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                  target="_blank"
                >
                  Área do Cliente
                </a>
              </p>
              <p className="passo-gerar-boleto">
                <b>2.</b> Clique no item do menu Antecipar ou 2ª via de boleto;
              </p>
              <p className="passo-gerar-boleto">
                <b>3.</b> Selecione as parcelas que deseja pagar;
              </p>
              <p className="passo-gerar-boleto">
                <b>4.</b> Clique em Consultar parcelas e depois em Gerar boleto.
              </p>
            </div>
            <RedButton
              href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
              className="btn-boleto-venceu"
              target="_blank"
              rel="noopener"
            >
              Acessar Área do Cliente
            </RedButton>
          </ContainerHome24>
        </div>
        <div className="boleto-venceu-desk">
          <ContainerHome24>
            <picture>
              <source type="image/webp" srcSet="assets/boleto25/img-boleto-venceu-desk.webp" />
              <source type="image/png" srcSet="assets/boleto25/img-boleto-venceu-desk.png" />
              <img
                src="assets/boleto25/img-boleto-venceu-desk.png"
                alt="Mulher branca de cabelo curto pesquisando sobre vencimento do boleto."
                className="img-boleto-venceu"
              />
            </picture>

            <div className="boleto-venceu-desk-conteudo">
              <h3 className="boleto-venceu-titulo">Seu boleto venceu?</h3>
              <p className="boleto-venceu-texto">
                Ao realizar o pagamento de seu boleto vencido, você evita o aumento dos juros e
                conta com um dia a dia mais confortável para você e sua família. Confira abaixo como
                gerar a 2ª via de seu boleto:
              </p>
              <div className="passos-gerar-boleto">
                <p className="passo-gerar-boleto">
                  <b>1.</b> Acesse o{' '}
                  <a
                    href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                    target="_blank"
                  >
                    Área do Cliente
                  </a>
                </p>
                <p className="passo-gerar-boleto">
                  <b>2.</b> Clique no item do menu Antecipar ou 2ª via de boleto;
                </p>
                <p className="passo-gerar-boleto">
                  <b>3.</b> Selecione as parcelas que deseja pagar;
                </p>
                <p className="passo-gerar-boleto">
                  <b>4.</b> Clique em Consultar parcelas e depois em Gerar boleto.
                </p>
              </div>
              <RedButton
                href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                className="btn-boleto-venceu"
                wide
                target="_blank"
                rel="noopener"
              >
                Acessar Área do Cliente
              </RedButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default Boleto25BoletoVenceu;
